export default __webpack_public_path__ + "5877d36a7340a172f0e3e12add295e0c.svg";